import { Injectable } from '@angular/core';

import { Page } from '../../model/orm/page.model';
import { DataService } from '../data.service';
import { SimpleRepository } from './_simple.repository';
import { IGetallDTO } from 'src/app/model/dto/getall.dto';

@Injectable()
export class PagesRepository extends SimpleRepository<Page> {
    public pagesHelp: Page[] = [];
    public pagesMore: Page[] = [];
    public pagesAcc: Page[] = [];
    public itemPage: Page = null;
    
    constructor(protected dataService: DataService) {
        super();
        this.sortBy = "pos";
    }
    
    public load(): Promise<void> {
        return new Promise((resolve, reject) => {
            if (new Date().getTime() - this.loadedAt < this.ttl) {
                resolve();
            } else {
                const dto: IGetallDTO = {sortBy: this.sortBy, sortDir: this.sortDir};
                this.dataService.pagesAll(dto).subscribe(res => {                    
                    if (res.statusCode === 200) {
                        this.build(res.data);
                        this.loadedAt = new Date().getTime();                        
                        resolve();
                    } else {                        
                        reject(res.statusCode+": "+res.error);
                    }
                }, err => {
                    reject(err.message);
                });
            }            
        });
    }    

    public build(pages: Array<Page> = []): void {
        this.xl = pages.length ? pages.map(d => new Page().build(d)) : [];                           
        this.pagesHelp = this.xl.filter(p => p.inmenu && p.section === 2);
        this.pagesMore = this.xl.filter(p => p.inmenu && p.section === 3);
        this.pagesAcc = this.xl.filter(p => p.section === 4);
        this.itemPage = this.xl.find(p => p.slug === "product") || null;
    }
}
